angular.module(
  'linshare.receivedShare',
  [
    'linshare.utils',
    'pascalprecht.translate',
  ]
);

require('./constants');
require('./receivedShareController');
require('./receivedShareRestService');
require('./receivedShareRestServiceRun');